import { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';

import { AuthContext } from '../../context/AuthContextProvider';
import PrimaryButton from '../../components/PrimaryButton';
import RoundedInput from '../../components/RoundedInput';
import AutoNavigate from '../../components/AutoNavigate';
import { defaultApiClient } from '../../apiClients/apiClient';

export default function RequestLoginOtpPage() {
    const navigate = useNavigate();

    const { loginOtpRequest, setLoginOtpRequest, setSignUpRequest } = useContext(AuthContext);

    const [isRequestingOtp, setIsRequestingOtp] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState(loginOtpRequest?.phoneNumber || '');

    const handleContinueButtonClick = async () => {
        // TODO: validate phone number before sending this request

        setIsRequestingOtp(true);

        let standardizedPhoneNumber = phoneNumber.replace(' ', '');
        if (standardizedPhoneNumber.length === 10) {
            standardizedPhoneNumber = '+91' + standardizedPhoneNumber;
        } else if (standardizedPhoneNumber.length === 12) {
            standardizedPhoneNumber = '+' + standardizedPhoneNumber;
        }

        const requestLoginOtpResponse = await defaultApiClient.methods.auth.requestLoginOtp(
            standardizedPhoneNumber
        );
        console.log(requestLoginOtpResponse);
        if (!requestLoginOtpResponse.success) {
            console.log(requestLoginOtpResponse);
            window.alert(
                `${requestLoginOtpResponse.error.userFriendlyError.title}: ${requestLoginOtpResponse.error.userFriendlyError.detail}`
            );
            setIsRequestingOtp(false);

            return;
        }

        setSignUpRequest(null);
        setLoginOtpRequest({
            phoneNumber: standardizedPhoneNumber,
            state: 'VERIFY_LOGIN_OTP',
        });
        navigate('/auth/verify-login-otp');
    };

    return (
        <Box
            sx={{
                width: '100vw',
                height: '100dvh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-evenly',
                alignItems: 'center',
            }}
        >
            <AutoNavigate />
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <img src="/text-icon-high-res.png" style={{ height: '7vh' }} />
                <img src="/login.png" style={{ height: '35vh' }} />
            </Box>

            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Box
                    sx={{
                        width: '80%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mb: 2,
                    }}
                >
                    <RoundedInput
                        placeholder="Enter phone number"
                        icon={<LocalPhoneIcon />}
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        type="tel"
                    />
                </Box>

                <PrimaryButton
                    text="Continue"
                    fontSizeOverride={16}
                    onClick={handleContinueButtonClick}
                    loading={isRequestingOtp}
                    disabled={isRequestingOtp}
                />

                <Typography>
                    Don't have an account?{' '}
                    <Link
                        href="/auth/sign-up"
                        underline="always"
                        sx={{
                            color: 'rgb(39,90,71)',
                            textDecorationColor: 'rgb(39,90,71)',
                            fontWeight: 500,
                            '&:visited': {
                                color: 'rgb(39,90,71)',
                            },
                            '&:hover': {
                                color: 'rgb(39,90,71)',
                            },
                        }}
                    >
                        Press Here to Sign up
                    </Link>
                </Typography>
            </Box>
        </Box>
    );
}
